import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import { Portal } from 'projects/brn-frontend/src/app/core/models/portal.model';
import { PortalService } from 'projects/brn-frontend/src/app/core/services/portal.service';
import {
  ConnectionsSelectors,
  CreateBotConnection,
  RemoveBotConnection,
  UpdateBotConnection,
} from 'projects/brn-frontend/src/app/core/store/bot-connections';
import { BotSelectors } from 'projects/brn-frontend/src/app/core/store/bot/bot.selectors';

@Component({
  selector: 'brn-skype-connection-modal',
  templateUrl: './skype-connection-modal.component.html',
  styleUrls: ['./skype-connection-modal.component.scss'],
})
export class SkypeConnectionModalComponent implements OnInit {
  @ViewSelectSnapshot(ConnectionsSelectors.pendingStatus)
  pendingStatus!: boolean;
  @ViewSelectSnapshot(BotSelectors.botId)
  botId!: string;

  newConnection = true;

  skypeForm = this.formBuilder.group({
    client_id: ['', Validators.required],
    secret: ['', Validators.required],
  });

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<SkypeConnectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboard: Clipboard,
    private snackbar: MatSnackBar
  ) {
    if (data.providerData) {
      this.newConnection = false;
      this.skypeForm.patchValue(data.providerData);
    }
  }

  ngOnInit(): void {}

  get apiEndpoint(): string {
    const botId = this.botId || this.data.botId || 'undefined';
    return `${PortalService.ApiUrl}/message/receive/skype?bot_id=${botId}`;
  }

  get validForm(): boolean {
    return this.skypeForm.valid;
  }

  copyToClipboard(): void {
    this.clipboard.copy(this.apiEndpoint);
    this.snackbar.open('Copied to clipboard', '', {
      duration: 3000,
      panelClass: 'success',
    });
  }

  createConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.skypeForm.value;
    this.store.dispatch(new CreateBotConnection('skype', providerData));
  }

  updateConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.skypeForm.value;
    this.store.dispatch(new UpdateBotConnection('skype', providerData));
  }

  removeConnection(): void {
    if (this.pendingStatus) {
      return;
    }
    this.store.dispatch(new RemoveBotConnection('skype'));
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
